import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { BarChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent
} from 'echarts/components'

echarts.use([
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer
])

import { MrpLogResult } from "interface/carenet/mrp"
import { useCallback, useMemo } from 'react'
import { DateToDay, DayToDate, numberFormat, safeParseDate } from 'shared/util'
import { useTooltip } from 'features/dashBoard/components/graph/components/toolTip'

export type MrpLogGraphOptions = {
	isSummary: boolean
}
type MrpLogGraphProps = {
	mrpLog: MrpLogResult[]
	haisinCount: number
	option: MrpLogGraphOptions
	height: number
}
export const MrpLogGraph = ({
	mrpLog,
	//haisinCount,
	option,
	height
}: MrpLogGraphProps) => {
	const tooltip = useTooltip({ trigger: 'axis', valueDef: { unit: '件' } })
	const valueFormatter = useCallback(
		(value: number) => {
			if (value === undefined || value === null) return ''
			return numberFormat(value)
		},
		[]
	)	
	const { xAxisData, seriesData } = useMemo(
		() => {
			let minTime: Date | null = null
			let maxTime: Date | null = null
			const timeLine: { day: number, count: number }[] = []
			for (const log of mrpLog) {
				const time = safeParseDate(log.firstviewdate)
				if (!time) continue

				const day = DateToDay(time)
				const t = timeLine.find(t => t.day === day)
				if (t) {
					t.count += 1
				} else {
					timeLine.push({ day, count: 1 })
				}
				if (minTime === null || minTime.getTime() > time.getTime()) minTime = time
				if (maxTime === null || maxTime.getTime() < time.getTime()) maxTime = time
			}
			if (minTime === null || maxTime === null) {
				return { xAxisData: [], seriesData: [] }
			}
			const minDay = DateToDay(minTime)
			const maxDay = DateToDay(maxTime)
			let total = 0
			const bars = Array.from(Array((maxDay - minDay) + 1), (_, day) => {
				const count = timeLine.find(t => t.day === minDay + day)?.count ?? 0
				total += count
				return {
					date: DayToDate(minDay + day),
					count: option.isSummary ? total : count
				}
			})
			return {
				xAxisData: bars.map(({ date }) => {
					const day = date.getDate()
					const month = date.getMonth()
					return `${month+1}/${day}`
				}),
				seriesData: bars.map(bar => bar.count)
			}
		},
		[mrpLog, option]
	)
	return (
		<ReactEChartsCore
			echarts={echarts}
			notMerge={true}
			option={{
				tooltip,
				xAxis: {
					type: 'category',
					axisTick: { show: false },
					axisLabel: {
						align: 'center'
					},
					data: xAxisData
				},
				yAxis: {
					type: 'value',
					axisLabel: {
						formatter: valueFormatter
					}
				},
				series: {
					type: 'bar',
					barGap: "5%",
					xAxisIndex: 0,
					yAxisIndex: 0,
					data: seriesData
				},
				grid: {
					top: 10, bottom: 10, left: 10, right: 10,
					containLabel: true
				},
				textStyle:{
					fontFamily: 'Noto Sans JP,sans-serif'
				}
			}}
			opts={{
				renderer: 'canvas',
				width: 'auto',
				height
			}}
			theme="insite"
		/>
	)
}